export enum WriteMode {
	OverwriteExistingFile = 0,
	ErrorOnExistingFile = 1,
}
